import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMarkerCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="marker-circle,highlight"><path d="M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5"/><path d="M6 18.5C7.5 16.9 8 13.75 8 13.75H16C16 13.75 16.5 16.9 18 18.5" stroke="currentColor" strokeWidth="1.5"/><path d="M9 13.25V9.75L15 8.25V13.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMarkerCircle;
